import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC } from "./getPresignedDocumentUploadUrlForSpocRespondentUnmappingRPC";

export class GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPCClientImpl extends GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC.Request): Promise<LeoRPCResult<GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC.Response, GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/GetPresignedDocumentUploadURLForSpocRespondentUnmapping",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC.ResponseDTO,
      GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC.Errors.ErrorsDTO,
      GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC.Response,
      GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC.Errors.Errors
    >(
      response,
      "spoc-management/GetPresignedDocumentUploadURLForSpocRespondentUnmapping",
      GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC.Response.fromDTO,
      GetPresignedDocumentUploadURLForSpocRespondentUnmappingRPC.Errors.fromDTO
    );
  }
}
